import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SbdoApiService {

  constructor() { }

  checkCompatibility(connectedVersion: any) {
    throw new Error('Method not implemented.');
  }

  getAppQueueId(appId: any, clientId: any) {
    throw new Error('Method not implemented.');
  }

  refreshVehicleTopology() {
    throw new Error('Method not implemented.');
  }
}
